<script setup lang="ts">
import type { ComponentStyles } from 'types/index';
import type { UmbracoForm } from 'types/blocks';

defineProps<{
  componentStyles: ComponentStyles;
  data: UmbracoForm;
}>();
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <div class="container">
      <BaseForm :form-data="data.formPicker" />
    </div>
  </BaseComponentWrapper>
</template>
